import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveImage, formatRM } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { i18n } = useTranslation();
  const zh = i18n.language?.startsWith("en") ? false : true;
  const name = zh ? product.name_zh : product.name_en;
  const hasPromo = product.promo_price && product.promo_price < product.price;
  const img = resolveImage((product.images || [])[0]);

  return (
    <Link
      to={`/products/${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative overflow-hidden rounded-md bg-[#f5f0e8] aspect-[4/5]">
        {img ? (
          <img
            src={img}
            alt={name}
            className="card-img absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-[#4a6e77] text-sm">
            {name}
          </div>
        )}
        {hasPromo && (
          <span className="absolute top-3 left-3 rounded-full bg-white/95 text-[#005870] text-[10px] font-semibold px-2.5 py-1 tracking-wide">
            PROMO
          </span>
        )}
        {product.featured && (
          <span className="absolute top-3 right-3 rounded-full bg-[#005870] text-white text-[10px] font-semibold px-2.5 py-1 tracking-wide">
            ★
          </span>
        )}
      </div>
      <div className="mt-4">
        <div className="text-[15px] font-serif-cn text-[#003645] font-medium truncate group-hover:text-[#00868e] transition-colors duration-200">
          {name}
        </div>
        <div className="mt-1 text-xs uppercase tracking-widest text-[#4a6e77]/70">
          {zh ? product.name_en : product.name_zh}
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-[#005870] font-semibold text-base">
            {formatRM(product.promo_price || product.price)}
          </span>
          {hasPromo && (
            <span className="text-xs text-[#4a6e77] line-through">
              {formatRM(product.price)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
